module.exports = __webpack_public_path__ + "img/coricidin_hbp_maximum_strength_cold_cough_flu_medicine_liquid_gels.a4944515.png";